const config = {
    // hostname: "http://192.168.1.81:3000/api",
    // hostname: "http://127.0.0.1:3000/api",
    // hostname: "http://172.20.0.226:3000/api"
    // hostname: "http://13.235.215.57:8081/api",
    // hostname: "http://3.111.45.150:8081/api", //demo
    hostname: "https://appv3.egoalprime.com:4443/api", //v2 production
    // hostname: "http://localhost:4000/api", //V3 local dev — backend on port 4000, frontend on 8085
    //  hostname: "https://aldar.egoalprime.com/v3api/api", //aldar
};
// };

/**
 * Re-root a backend asset URL (e.g. floor-plan images served from /uploads) onto
 * the same host the SPA was loaded from. The backend persists absolute URLs at
 * upload time (often `http://localhost:<port>/uploads/...`), which are unreachable
 * — and blocked by the browser's private-network policy — when the app is opened
 * from another machine via the public IP. Keeping only the path and re-rooting it
 * on the current API origin makes assets load both locally and remotely without
 * baking a host into the database. Leaves data:/blob: URLs untouched.
 */
export function resolveAssetUrl(url) {
    if (!url || /^(data|blob):/i.test(url)) return url;
    const base = config.hostname.replace(/\/api\/?$/, ''); // strip /api → asset origin
    try {
        const u = new URL(url, base);
        const b = new URL(base);
        u.protocol = b.protocol;
        u.host = b.host; // re-root host:port, keep the path/query
        return u.toString();
    } catch {
        return url;
    }
}

export default config;
